module.exports = __webpack_public_path__ + "static/img/Watson.b3954d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Watson.jpg
// module id = MccG
// module chunks = 0